import { extractStringValueSet } from './extract-properties';

export class NGSAssay {

    static readonly XE: string = 'xE';
    static readonly XEV2: string = 'xE.v2';
    static readonly XF: string = 'xF';
    static readonly XO: string = 'xO';
    static readonly XT: string = 'xT';
    static readonly RS: string = 'RS';
    static readonly RSV2: string = 'RS.v2';
    static readonly XTV2: string = 'xT.v2';
    static readonly XTV3: string = 'xT.v3';
    static readonly XTV4: string = 'xT.v4';
    static readonly XFV2: string = 'xF.v2';
    static readonly XG: string = 'xG';
    static readonly NPV2: string = 'nP.v2'; // a.k.a. xG.v2
    static readonly XGV1: string = 'xG-onco.v1';
    static readonly XMV1: string = 'xM.v1';
    static readonly XFV3: string = 'xF.v3';
    static readonly XFV4: string = 'xF.v4';
    static readonly XTONCOV1: string = 'xT-onco.v1';
    static readonly XGV2: string = 'xG-onco.v2';
    static readonly RNAONCOV1: string = 'rna-onco.v1';
    static readonly NPV3: string = 'nP.v3';
    static readonly SKYLINEMERLIN: string = 'skyline-merlin';
    static readonly XFCDXV1: string = 'xFCDx.v1';
    static readonly XHV1: string = 'xH.v1';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
